import React from "react";
import { withBundle, WithBundleProps } from "@amzn/react-arb-tools";
import CloudScapeSplitPanel from "@cloudscape-design/components/split-panel";
import { PanelContextType } from "../../context/PanelContextProvider";
import { USER_ACTIONS } from "../../constants/constants";

//It is a placeholder where we will build tasks page form
export interface TasksPageFormProps extends WithBundleProps {
  taskRecord: any; //todo will change this any during API integration this prop is used to prefill form data while edit mode
  panelContext: PanelContextType | undefined;
  panelType: USER_ACTIONS.EDIT | USER_ACTIONS.CREATE;
}

export const TasksPageForm = withBundle("pages.TasksPageForm")(
  (props: TasksPageFormProps) => {
    return (
      <CloudScapeSplitPanel
        header={
          props.panelType === USER_ACTIONS.EDIT
            ? props.bundle.getMessage("edit_task")
            : props.bundle.getMessage("new_task")
        }
        hidePreferencesButton={true}
        closeBehavior="hide"
      >
        <p>Tasks Page Form comes here</p>
      </CloudScapeSplitPanel>
    );
  }
);
